import { IConfigSafe } from '@cian/config/shared';
import { ILogger } from '@cian/logger';
import axios from 'axios';

export const axiosInstance = axios.create({ timeout: 5000 });

export function setupAxiosInstance(config: IConfigSafe, logger: ILogger) {
  const apiClientTimeout = config.get<number>('mp-auth-micro-frontend.apiClientTimeout');

  if (apiClientTimeout.isOk()) {
    axiosInstance.defaults.timeout = apiClientTimeout.Ok;
  } else {
    logger.warning('Failed to get from config: mp-auth-micro-frontend.apiClientTimeout');
  }
}
